/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_SceneInputs */

const en_settings_credits_scene = /** @type {(inputs: Settings_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene`)
};

/**
* | output |
* | --- |
* | "Scene" |
*
* @param {Settings_Credits_SceneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_scene = /** @type {((inputs?: Settings_Credits_SceneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_SceneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_scene(inputs)
});
export { settings_credits_scene as "settings.credits.scene" }